import {
  forwardRef,
} from 'react';
import {
  type TournamentLeaderboardItem
} from '@entities/tournaments';

export type TournamentTbodyRowItemProps = {
  rowHeight?: number;
  leaderboardItem: TournamentLeaderboardItem;
};

export const TournamentTbodyRowItem = forwardRef<HTMLTableRowElement, TournamentTbodyRowItemProps>(
  ({ leaderboardItem, rowHeight }, ref) => {
    const { rank, player, score, toWin, isCurrentPlace } = leaderboardItem
    return (
      <tr
        ref={ref}
        className={isCurrentPlace ? 'current-place' : ''}
        style={{ height: rowHeight ? `${rowHeight}px` : undefined }}>
        <td className={rank <= 3 ? `highlight highlight-${rank}` : ''}>{rank}</td>
        <td>{player}</td>
        <td>{score}</td>
        <td>{toWin}</td>
      </tr>
    );
  }
);